"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _CacheContext = require("../context/CacheContext");

var _cacheActions = require("../reducers/cache/cacheActions");

var _useSchema3 = _interopRequireDefault(require("./useSchema"));

var _traversePath = _interopRequireDefault(require("../libs/traversePath"));

var _formatters = require("../libs/formatters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useCache = function useCache() {
  var _useContext = (0, _react.useContext)(_CacheContext.store),
      cacheState = _useContext.cacheState,
      cacheDispatch = _useContext.cacheDispatch;

  var _useSchema = (0, _useSchema3["default"])(),
      _useSchema2 = _slicedToArray(_useSchema, 1),
      references = _useSchema2[0].references;

  var update = (0, _react.useCallback)(function (_ref) {
    var _references$data$type, _references$data$type2;

    var awyesId = _ref.awyesId,
        data = _ref.data,
        fromUpdate = _ref.fromUpdate;
    var otherUpdates = {};
    var nestedTypes = Object.keys((_references$data$type = references === null || references === void 0 ? void 0 : (_references$data$type2 = references[data === null || data === void 0 ? void 0 : data.typeName]) === null || _references$data$type2 === void 0 ? void 0 : _references$data$type2.cachePaths) !== null && _references$data$type !== void 0 ? _references$data$type : {}).filter(function (nestedType) {
      return nestedType !== 'AwyesImage';
    });

    if (nestedTypes.length) {
      nestedTypes.forEach(function (nestedType) {
        var _references$data$type3;

        var paths = (_references$data$type3 = references[data.typeName].cachePaths[nestedType]) !== null && _references$data$type3 !== void 0 ? _references$data$type3 : [];
        paths.forEach(function (path) {
          otherUpdates = _objectSpread(_objectSpread({}, otherUpdates), (0, _traversePath["default"])({
            parentId: awyesId,
            path: path,
            data: data
          }));
        });
      });
    }

    cacheDispatch({
      type: _cacheActions.UPDATE,
      updates: _objectSpread(_objectSpread({}, otherUpdates), {}, _defineProperty({}, awyesId, data)),
      awyesId: awyesId,
      fromUpdate: fromUpdate
    });
  }, [references]);
  var editPage = (0, _react.useCallback)(function (_ref2) {
    var awyesId = _ref2.awyesId,
        route = _ref2.route;

    var _extractAwyesId = (0, _formatters.extractAwyesId)(awyesId),
        id = _extractAwyesId.id,
        typeName = _extractAwyesId.typeName;

    cacheDispatch({
      type: _cacheActions.EDIT_PAGE,
      awyesId: awyesId,
      id: id,
      typeName: typeName,
      route: route
    });
  }, [references]);
  var temporary = (0, _react.useCallback)(function (_ref3) {
    var awyesId = _ref3.awyesId,
        field = _ref3.field,
        value = _ref3.value;
    cacheDispatch({
      type: _cacheActions.TEMPORARY,
      awyesId: awyesId,
      field: field,
      value: value
    });
  }, []);
  var remove = (0, _react.useCallback)(function (_ref4) {
    var awyesId = _ref4.awyesId;
    cacheDispatch({
      type: _cacheActions.REMOVE,
      awyesId: awyesId
    });
  }, []);
  var removeTemporary = (0, _react.useCallback)(function (_ref5) {
    var awyesId = _ref5.awyesId;
    cacheDispatch({
      type: _cacheActions.REMOVE_TEMPORARY,
      awyesId: awyesId
    });
  }, []);
  return [cacheState, {
    update: update,
    temporary: temporary,
    remove: remove,
    removeTemporary: removeTemporary,
    editPage: editPage
  }];
};

var _default = useCache;
exports["default"] = _default;